import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase";

const sendReplyFn = httpsCallable(functions, "sendReply");
const POLL_MS = 15000;

function callableError(err) {
  return err?.message || err?.details || "Request failed.";
}

/** Public submit — triggers onSupportTicketCreated (ack email + AI triage). */
export async function createSupportTicket({
  name,
  email,
  role = "fan",
  category = "general",
  subject,
  message,
}) {
  return addDoc(collection(db, "support_tickets"), {
    name: (name || "").trim(),
    email: (email || "").trim().toLowerCase(),
    role,
    category,
    subject: (subject || "").trim(),
    message: (message || "").trim(),
    status: "open",
    priority: null,
    aiDraftReply: null,
    createdAt: serverTimestamp(),
  });
}

export function subscribeSupportTickets(onData, onError) {
  let cancelled = false;

  const load = async () => {
    try {
      const data = await listSupportTickets();
      if (!cancelled) onData(data);
    } catch (err) {
      console.error("Support tickets load error:", err);
      if (!cancelled) onError?.(err);
    }
  };

  load();
  const timer = setInterval(load, POLL_MS);

  let cleaned = false;
  return () => {
    if (cleaned) return;
    cleaned = true;
    cancelled = true;
    clearInterval(timer);
  };
}

export async function listSupportTickets() {
  const q = query(collection(db, "support_tickets"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function updateTicketDraft(ticketId, aiDraftReply) {
  await updateDoc(doc(db, "support_tickets", ticketId), {
    aiDraftReply,
    updatedAt: serverTimestamp(),
  });
}

export async function sendReply({ ticketId, replyText }) {
  try {
    const { data } = await sendReplyFn({ ticketId, replyText });
    return data;
  } catch (err) {
    throw new Error(callableError(err));
  }
}

export async function markResolved(ticketId) {
  await updateDoc(doc(db, "support_tickets", ticketId), {
    status: "resolved",
    resolvedAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}
